module.exports = __webpack_public_path__ + "static/media/createChannelIcon.9fc25b6c.svg";